"use client";

import { ReactNode, useEffect } from "react";
import { useCart, CartItem } from "@/context/CartContext";

export type SoftCartItem = CartItem;

export function SoftCartProvider({
  children,
  subdomain,
}: {
  children: ReactNode;
  subdomain?: string;
}) {
  // পুরানো soft_cart-এ কোনো আইটেম থাকলে তা সরাসরি মূল xylo_cart-এ ট্রান্সফার ও সিঙ্ক
  useEffect(() => {
    if (!subdomain || typeof window === "undefined") return;
    try {
      const oldSoftCartKey = `soft_cart_${subdomain}`;
      const globalCartKey = `xylo_cart_${subdomain}`;

      const oldSoftData = localStorage.getItem(oldSoftCartKey);
      const currentGlobalData = localStorage.getItem(globalCartKey);

      if (oldSoftData && oldSoftData !== "[]") {
        if (!currentGlobalData || currentGlobalData === "[]") {
          localStorage.setItem(globalCartKey, oldSoftData);
        } else {
          // উভয় কার্টের আইটেম মার্জ করা
          const softItems = JSON.parse(oldSoftData);
          const globalItems = JSON.parse(currentGlobalData);
          
          const merged = [...globalItems];
          softItems.forEach((sItem: any) => {
            const idx = merged.findIndex((g: any) => g.id === sItem.id);
            if (idx > -1) {
              merged[idx].quantity += sItem.quantity;
            } else {
              merged.push(sItem);
            }
          });
          localStorage.setItem(globalCartKey, JSON.stringify(merged));
        }
        localStorage.removeItem(oldSoftCartKey);
        window.location.reload();
      }
    } catch (err) {
      console.error("Cart migration error:", err);
    }
  }, [subdomain]);

  return <>{children}</>;
}

// মূল গ্লোবাল কার্ট হুক এক্সপোর্ট করা হলো, যাতে সব থিমে একই স্টেট কার্যকর থাকে
export const useSoftCart = useCart;